import type { MatchEvent } from "@arcade-hockey/shared";
import { InputButton } from "@arcade-hockey/shared";
import { clamp01 } from "../math/Geometry.js";
import { tuning } from "../state/tuning.js";
import type { PlayerState, PuckState } from "../state/types.js";

type PassInputView = {
  buttons: number;
};

export function applyPassInput(
  player: PlayerState,
  puck: PuckState,
  input: PassInputView,
  currentTick: number,
): MatchEvent | null {
  const isHeld = (input.buttons & InputButton.Pass) !== 0;
  const wasHeld = player.passHoldTicks > 0;
  if (!player.hasPuck) {
    player.passHoldTicks = 0;
    return null;
  }

  if (isHeld) {
    player.passHoldTicks = Math.min(player.passHoldTicks + 1, tuning.pass.holdMaxTicks);
    return null;
  }

  if (!wasHeld) return null;

  const heldTicks = player.passHoldTicks;
  player.passHoldTicks = 0;

  const dirX = player.stickDir.x;
  const dirY = player.stickDir.y;

  const charge = clamp01(heldTicks / tuning.pass.holdMaxTicks);
  const speed = tuning.pass.speedMin + (tuning.pass.speedMax - tuning.pass.speedMin) * charge;

  puck.vel.x = dirX * speed;
  puck.vel.y = dirY * speed;
  puck.mode = "Pass";
  puck.ownerId = null;
  puck.lastTouchedBy = player.id;
  puck.noRecaptureUntilTick = currentTick + tuning.puck.noRecaptureTicks;
  player.hasPuck = false;
  player.possessionQuality = 0;

  return {
    type: "PassReleased",
    tick: currentTick,
    from: player.id,
    targetPlayerId: null,
    speed,
  };
}
